import Popup from './Popup'

export default function QuickSupport() {
  return <Popup name="quick-support" componentId={4361} />
}
